import type { SupportedLocale } from '@optiflow/types';

const LOCALE_TAG: Record<SupportedLocale, string> = {
  en: 'en-GB',
  ar: 'ar-EG',
};

export function formatDate(value: string | Date, locale: SupportedLocale): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';

  return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
    dateStyle: 'medium',
  }).format(date);
}

/** A count in the viewer's digits, as money and dates are: Arabic-Indic in Arabic. */
export function formatCount(value: number, locale: SupportedLocale): string {
  return new Intl.NumberFormat(LOCALE_TAG[locale]).format(value);
}

export function formatDateTime(value: string | Date, locale: SupportedLocale): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';

  return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

/** "Main, Second and Third", joined the way the viewer's language joins a list. */
export function formatList(values: readonly string[], locale: SupportedLocale): string {
  return new Intl.ListFormat(LOCALE_TAG[locale], { style: 'long', type: 'conjunction' }).format(
    values,
  );
}

export function initials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}
